export const goalHelpIdMapping = {
  GoalCategory: 'pop_BA_ConversionGoal_GoalCategory',
  Type: 'pop_BA_UET_Type',
  Revenue: 'pop_BA_UET_RevenueValue',
  IsAccountLevel: 'pop_BA_UET_Scope',
  ConversionCountType: 'pop_BA_UET_Count',
  IsMainConversionGoal: 'pop_BA_ConversionGoal_CountAsConv',
  LookbackWindowInMinutes: 'pop_BA_UET_ConversionWindow',
  ViewThroughLookbackWindowinMinutes: 'pop_BA_UET_VTCWindow',
  Status: 'pop_BA_UET_Status',
  AttributionModelType: 'pop_BA_CampaignGrids_AttributionModelType',
  Tag: 'pop_BA_UET_UETTag',
  OptimizeCampaign: 'pop_BA_UET_AutoConversions_OptimizingCampaigns',
  EnhancedConversions: 'pop_BA_UET_AutoConversions_EnhancedConversions',
};
